

































































    import Vue, { PropOptions } from 'Vue';
    import Vuex from 'Vuex';
    import { DataTableFactory } from './dataTableFactory';
    import { ISchemaColumn, ITableHeader, ITableFilter, FilterTypeEnum } from '../../../../../../CommonScripts/Abstractions';
    import { Feature } from 'geojson';
    import { isUrl, isDate, isEmail, isInteger, isNumber, isUnsignedInteger, notEmpty  } from '../../../Core/validation';
    import dateCompoent from './dateComponent.vue';
    export default Vue.extend({
        name: 'application-feature-table',
        components: {
            'feature-table-date': dateCompoent
        },
        props: {
            headers: { type: Array as () => Array<ITableHeader>, required: true, default: () => { [] } } as PropOptions<ITableHeader[]>,
            items: { type: Array as () => Array<Feature>, required: true, default: () => { [] } } as PropOptions<Feature[]>,
            overlay: { type: Object, required: false, default: null } as PropOptions<object>,
            fixedHeader: { type: Boolean, required: false, default: true } as PropOptions<boolean>,
            height: { type: String, required: false, default: null } as PropOptions<string>,
            closeLabel: { type: String, required: false, default: null } as PropOptions<string>,
            closeToolTip: { type: String, required: false, default: null } as PropOptions<string>,
            viewLabel: { type: String, required: false, default: null } as PropOptions<string>,
            viewToolTip: { type: String, required: false, default: null } as PropOptions<string>,
            showFilter: { type: Boolean, required: false, default: true } as PropOptions<boolean>,
            currentFilter: { type: Object as () => ITableFilter, required: false, default: () => null } as PropOptions<ITableFilter>
        },
        data(): {
            factory: DataTableFactory, filter: ITableFilter, selectedColumn: ITableHeader, filterType: FilterTypeEnum, filterValue: any, rules: {
                notEmpty: (value: string) => string | boolean,
                isInteger: (value: string) => string | boolean,
                isUnsignedInteger: (value: string) => string | boolean,
                isNumber: (value: string) => string | boolean
            }
        } {
            return {
                factory: new DataTableFactory(), filter: null, selectedColumn: null, filterType: null, filterValue: null, rules: {
                    notEmpty: (value: string) => {
                        let retVal = notEmpty(value);
                        if (retVal !== true)
                            retVal = this.$vuetify.lang.t(retVal as string);
                        return retVal;
                    },
                    isInteger: (value: string) => {
                        let retVal = isInteger(value);
                        if (retVal !== true)
                            retVal = this.$vuetify.lang.t(retVal as string);
                        return retVal;
                    },
                    isUnsignedInteger: (value: string) => {
                        let retVal = isUnsignedInteger(value);
                        if (retVal !== true)
                            retVal = this.$vuetify.lang.t(retVal as string);
                        return retVal;
                    },
                    isNumber: (value: string) => {
                        let retVal = isNumber(value);
                        if (retVal !== true)
                            retVal = this.$vuetify.lang.t(retVal as string);
                        return retVal;
                    },
                }
            };
        },
        methods: {
            validate(): boolean {
                const ref = this.$refs['userInput'];
                let valid = true;
                if (this.selectedColumn.type !== 7) {//force validation of everything but dates
                    const refValid = (ref as Vue & { validate: (param: boolean) => boolean | string }).validate(true);
                    if (refValid !== true) {
                        valid = false;
                    }
                }

                return valid;
            },
            clearFilterHandler(): void {
                this.filter = null;
                this.selectedColumn = null;
                this.filterType = null;
                this.filterValue = null;
                this.$emit('filterCleared');
            },
            applyFilterHandler(): void {
                if (this.validate()) { 
                    const filter: ITableFilter = {
                        filterType: this.filterType,
                        searchColumn: this.selectedColumn,
                        value: this.filterValue
                    };
                    this.filter = filter;
                    this.$emit('filterChanged', { filter: filter });
                }
            },
            removeColumn(header: ITableHeader): void {
                this.$emit('removeHeader', { header: header });
            },
            viewClickedHandler(feature: Feature): void {
                this.$emit('view', { feature: feature });
            },
            isUrl(rowData: any, header: ITableHeader): boolean {
                let retVal = false;
                if (header.type === 8 && rowData.properties[header.value]) {//string
                    let validation: boolean | string = isUrl(rowData.properties[header.value]);
                    retVal = validation === true ? true : false;
                }
                return retVal;
            },
            getCellData(rowData: any, header: ITableHeader): any {
                return this.factory.getCellData(this.overlay, rowData, header);
            },
            sortFunction(items: any[], index: string[], isDesc: boolean[], locale: string, customSorters: Record<string, (a: any, b: any) => number>): any[] {
                if (items.length > 0 && index.length > 0 && isDesc.length > 0 && customSorters[index[0]]) {
                    items.sort((a, b): number => {
                        let retVal = 0;
                        if (isDesc[0])
                            retVal = customSorters[index[0]](a.properties[index[0]], b.properties[index[0]]);
                        else
                            retVal = customSorters[index[0]](b.properties[index[0]], a.properties[index[0]]);
                        return retVal;
                    })
                }
                return items;
            },
            headerWidth(header: ITableHeader): string {
                let style = '';
                if (header.sortable)
                    style = 'width:calc(100% - 20px)';//leave room for the sort arrow
                else
                    style = 'width:100%';

                return style;
            },
            getFilterTypeText(filterType: FilterTypeEnum): string {
                let retVal = '';
                switch (filterType) {
                    case FilterTypeEnum.None:
                        retVal = this.$vuetify.lang.t('webmap.featureTable.filterTypes.none');
                        break;
                    case FilterTypeEnum.Contains:
                        retVal = this.$vuetify.lang.t('webmap.featureTable.filterTypes.contains');
                        break;
                    case FilterTypeEnum.Equals:
                        retVal = this.$vuetify.lang.t('webmap.featureTable.filterTypes.eq');
                        break;
                    case FilterTypeEnum.GreaterThan:
                        retVal = this.$vuetify.lang.t('webmap.featureTable.filterTypes.gt');
                        break;
                    case FilterTypeEnum.GreaterThanEquals:
                        retVal = this.$vuetify.lang.t('webmap.featureTable.filterTypes.gteq');
                        break;
                    case FilterTypeEnum.LessThan:
                        retVal = this.$vuetify.lang.t('webmap.featureTable.filterTypes.lt');
                        break;
                    case FilterTypeEnum.LessThanEquals:
                        retVal = this.$vuetify.lang.t('webmap.featureTable.filterTypes.lteq');
                        break;
                }
                return retVal;
            },
            selectedColumnChanged(): void {
                this.filterValue = null;
                this.filterType = null;
                if (this.selectedColumn) {
                    switch (this.selectedColumn.type) {
                        case 11:
                            this.filterValue = true;
                            break;
                        default:
                            this.filterValue = null;
                    }
                }
            }

        },
        mounted: function () {
        },
        watch: {
            currentFilter: {
                handler(newVal: ITableFilter, oldVal: ITableFilter) {
                    if (newVal !== null) {
                        this.filter = { ...newVal };
                        this.selectedColumn = newVal.searchColumn;
                        this.filterType = newVal.filterType;
                        this.filterValue = newVal.value;
                    }
                    else {
                        this.filter = null;
                        this.selectedColumn = null;
                        this.filterType = null;
                        this.filterValue = null;
                    }
                }
            }
        },

        computed: {
            listItems(): { text: string, value: any }[] {
                let items: { text: string, value: any }[] =[];
                if (this.selectedColumn) {
                    switch (this.selectedColumn.type) {
                        case 11:
                            items.push({ text: this.$vuetify.lang.t('webmap.featureTable.labels.true'), value: true });
                            items.push({ text: this.$vuetify.lang.t('webmap.featureTable.labels.false'), value: false });
                            break;
                        default:
                            break;
                    }
                }
                return items;
            },
            availableColumns(): ITableHeader[] {
                let retVal: ITableHeader[] = [];
                if (this.headers !== null) {
                    retVal = this.headers.filter((header: ITableHeader) => {
                        return header.filterable;
                    });
                }
                return retVal;
            },
            filterItems(): Feature[] {
                let items: Feature[] = null;
                if (this.filter === null)
                    items = this.items ? [...this.items] : [];
                else
                    items = this.factory.filterData(this.items, this.filter);
                return items
            },
            filterTypes(): { text: string, value: FilterTypeEnum }[] {
                let retVal = [];
                if (this.selectedColumn) {
                    if (!(this.selectedColumn.allowedFilters & FilterTypeEnum.None)) {
                        for (let shift = 0; shift < 6; shift++) {
                            const val = 1 << shift;
                            if (this.selectedColumn.allowedFilters & val) {
                                retVal.push({
                                    text: this.getFilterTypeText(this.selectedColumn.allowedFilters & val),
                                    value: val
                                })
                            }
                        }
                    }
                }
                return retVal;
            },
            valueComponent(): string {
                let retVal = 'v-text-field';
                if (this.selectedColumn !== null) {
                    switch (this.selectedColumn.type) {
                        case 11:
                            retVal = 'v-select';
                            break;
                        case 7: //date
                            retVal = 'feature-table-date';
                            break;
                        default:
                            retVal = 'v-text-field';
                            break;
                    }
                }
                return retVal;
            },
            filterRules(): (() => boolean | string)[] {
                const rules = [];
                if (this.selectedColumn) {
                    switch (this.selectedColumn.type) {
                        case 11:// no rules
                        case 7:
                            break
                        case 8:// string
                            rules.push(this.rules.notEmpty);
                            break;
                        case 2: //integer values
                        case 3:
                        case 19:
                        case 20:
                        case 21:
                            rules.push(this.rules.notEmpty);
                            rules.push(this.rules.isInteger);
                            break;
                        default://everything else
                            rules.push(this.rules.notEmpty);
                            rules.push(this.rules.isNumber);
                            break;
                    }
                }
                return rules;
            },
            filterDisabled(): boolean {
                return this.items ? this.items.length === 0 : true;
            },
            tableHeight(): string {
                let height = this.height;
                if (this.showFilter)
                    height = (`${parseInt(this.height, 10) - 48}`);

                return height;
            },
            removeFilterDisabled(): boolean {
                return this.filter === null;
            },
            applyFilterDisabled(): boolean {
                return this.selectedColumn === null || this.filterType === null || this.filterValue === null || this.filterDisabled;
            },
            valueType(): string {
                let type = '';
                if (this.selectedColumn) {
                    switch (this.selectedColumn.type) {
                        case 7: //date
                        case 8: //string $ type columns
                        case 11: //boolean
                            //these are the original types, apart from boolean, so do nothing
                            type = 'text';
                            break;
                        default:
                            type = 'number';
                    }
                }
                return type;
            },
            textColourCss(): string {
                return this.$store.getters['textCssClass'];
            },
            buttonClass(): string {
                return `no-text-transform ${this.textColourCss}`;
            }
        }
    });
